import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

import { Container, Row, Col } from "reactstrap";

import {
  setPage,
  setSort,
  getAll,
  deleteOne,
  setDeleteStatus
} from "../../common/agency/actions";
import { hashFromObj } from "../../common/lib/utils/hash";

import Pagination from "../../browser/components/Pagination/Pagination";
import NumberOfItemsInTable from "../../browser/components/Table/NumberOfItemsInTable";
import HeaderRow from "../../browser/components/Table/HeaderRow";
import ConfirmDeleteModal from "../../browser/components/ConfirmModal/ConfirmDeleteModal";

import moment from "moment";
moment.locale("pl");

class All extends React.Component {
  constructor() {
    super();

    this.state = {
      deleteModals: [],
      rows: null
    };

    this.redirectToCreate = this.redirectToCreate.bind(this);
  }

  componentDidMount() {
    const { getAll } = this.props;

    getAll();
  }

  componentWillReceiveProps({ results, meta }) {
    const result = results && results.get(hashFromObj(meta && meta.toJS()));
    if (result && result.agencies) {
      const self = this;

      const rows = result.agencies;
      this.setState({
        rows: this.state.rows ? this.state.rows.concat(rows).unique() : rows
      });
    }
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  toggleDeleteModal(uid, e) {
    if (e) {
      e.stopPropagation();
    }

    let deleteModals = this.state.deleteModals;
    deleteModals[uid] = !deleteModals[uid];
    this.setState({
      deleteModals: deleteModals
    });
  }

  isLastOnPage() {
    const { results, meta } = this.props;
    const result = results && results.get(hashFromObj(meta && meta.toJS()));

    const resultMeta = result && result.meta;
    const numberOfPages =
      resultMeta && Math.ceil(resultMeta.all / meta.get("limit"));
    const currentPage = meta.get("currentPage");

    const rows = result && result.agencies && result.agencies;
    if (
      currentPage === numberOfPages &&
      rows.length === 1 &&
      currentPage !== 1
    ) {
      return true;
    }

    return false;
  }

  async deleteOne(uid) {
    const { deleteOne, getAll, setPage, meta } = this.props;

    await deleteOne({ uid });

    const currentPage = meta.get("currentPage");
    getAll();
    if (this.isLastOnPage()) {
      setPage(currentPage - 1);
    }
  }

  async afterDelete(uid) {
    const { setDeleteStatus } = this.props;

    this.toggleDeleteModal(uid);
    setDeleteStatus(0);
  }

  redirectToCreate() {
    const { pathname } = this.props;

    this.redirect(pathname + "/add");
  }

  redirectToSingle(uid) {
    const { pathname } = this.props;

    this.redirect(pathname + "/edit/" + uid);
  }

  render() {
    const {
      map,
      results,
      meta,
      setPage,
      setSort,
      apiHost,
      deleteStatus
    } = this.props;
    const result = results && results.get(hashFromObj(meta && meta.toJS()));

    const headerRow = (
      <tr>
        <th />
        <HeaderRow
          sortable
          setSort={setSort}
          field="name"
          meta={meta}
          name="Nazwa"
          type="alpha"
        />
        <th>Strona WWW</th>
        <th>Aktywny</th>
        <th>Max promowanych</th>
        <HeaderRow
          sortable
          setSort={setSort}
          field="createdAt"
          sortField="created_at"
          meta={meta}
          name="Utworzono"
          type="amount"
        />
        <th className="text-xs-center">Akcje</th>
      </tr>
    );

    const self = this;

    const rows =
      result &&
      result.agencies &&
      result.agencies.map(r => {
        const toggleDelete = self.toggleDeleteModal.bind(this, r);
        return (
          <tr
            key={map.getIn([r, "uid"])}
            onClick={this.redirectToSingle.bind(this, r)}
          >
            <td className="logo-column">
              {map.getIn([r, "logoFile", "uid"]) ? (
                <img
                  className="table-logo"
                  src={
                    apiHost +
                    "/v1/agency/image/" +
                    map.getIn([r, "logoFile", "uid"])
                  }
                />
              ) : (
                ""
              )}
            </td>
            <td>{map.getIn([r, "name"])}</td>
            <td>{map.getIn([r, "agencyUrl"])}</td>
            <td>{map.getIn([r, "isActive"]) ? "Tak" : "Nie"}</td>
            <td>{map.getIn([r, "promotedMax"])}</td>
            <td>{moment(map.getIn([r, "createdAt"])).format("llll")}</td>
            <td className="text-xs-center">
              <i
                className="actions remove fa fa-remove"
                onClick={toggleDelete}
              />
            </td>
          </tr>
        );
      });

    const modals =
      this.state.rows &&
      this.state.rows.map(r => {
        const toggleDelete = self.toggleDeleteModal.bind(this, r);
        const isOpen = self.state.deleteModals[r];
        return (
          <ConfirmDeleteModal
            key={r}
            color="danger"
            title="UWAGA!"
            content="Operacja jest nieodwracalna. Czy na pewno chcesz <b>usunąć agencję</b> i <b>oferty do niej należące</b>?"
            icon="times-circle"
            confirmButtonText="Usuń"
            cancelButtonText="Anuluj"
            cancelAction={toggleDelete}
            isOpen={isOpen}
            confirmAction={self.deleteOne.bind(self, r)}
            afterClose={self.afterDelete.bind(self, r)}
            isLoading={deleteStatus === 1}
            isSuccess={deleteStatus === 2}
            isError={deleteStatus === 3}
          />
        );
      });

    return (
      <div className="panel panel-default panel-table">
        <div className="panel-heading">
          Agencje
          <div className="tools">
            <i className="fa fa-plus" onClick={this.redirectToCreate} />
          </div>
          <span className="panel-subtitle" />
        </div>

        <div className="panel-body">
          <Row>
            <Col xs="12">
              <table className="table table-striped table-hover dataTable">
                <thead>{headerRow}</thead>
                <tbody>
                  {rows ? (
                    rows.length === 0 ? (
                      <tr>
                        <td className="loading-spinner-td" colSpan="100">
                          Brak wpisów
                        </td>
                      </tr>
                    ) : (
                      rows
                    )
                  ) : (
                    <tr>
                      <td className="loading-spinner-td" colSpan="100">
                        <i className="loading-spinner fa fa-2x fa-circle-o-notch fa-spin" />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Col>
          </Row>

          <Row className="panel-footer">
            <Col xs="5">
              <NumberOfItemsInTable
                meta={meta}
                resultMeta={result && result.meta}
              />
            </Col>

            <Col xs="7" className="flex-items-xs-right text-xs-right">
              <Pagination
                numberOfPages={
                  result && Math.ceil(result.meta.all / meta.get("limit"))
                }
                currentPage={meta.get("currentPage")}
                maxPagesDisplay={5}
                setPage={setPage}
              />
            </Col>
          </Row>
        </div>
        {modals}
      </div>
    );
  }
}

All.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(
  state => ({
    apiHost: state.config.apiHost,
    map: state.agency.map,
    results: state.agency.results,
    meta: state.agency.meta,
    deleteStatus: state.agency.deleteStatus
  }),
  { setPage, setSort, deleteOne, getAll, setDeleteStatus }
)(All);



// WEBPACK FOOTER //
// ./src/browser/agency/All.js